import { createContext } from "react";

import { Option } from "shared/api/api";
import { useListOptions } from "shared/api/hooks";

import { ContextWrapComponentProps } from "./types";

const MAX_LIMIT_OPTIONS = 2000;

export const VehicleOptionsContext = createContext<{
  options: Option[] | undefined;
}>({ options: undefined });

const VehicleOptionsContextWrapper = ({
  children,
}: ContextWrapComponentProps) => {
  const { data: options } = useListOptions({ limit: MAX_LIMIT_OPTIONS });

  const contextValue = { options };

  return (
    <VehicleOptionsContext.Provider value={contextValue}>
      {children}
    </VehicleOptionsContext.Provider>
  );
};

export default VehicleOptionsContextWrapper;
